import { useReactRouterDom } from './useReactRouterDom'
import { useTheme } from '../useTheme'
import { useWebRouter } from './useWebRouter'

export type RouterType = 'react-router' | 'web-router'

const routerFactory = (type: RouterType) => {
  if (type === 'web-router') {
    return useWebRouter
  }
  if (type === 'react-router') {
    return useReactRouterDom
  }
}

export type UseHistoryReturnType = {
  push: (route: string, options?: Record<any, any>) => void
  goBack: (num?: number) => void
}

/**
 * Needs a wrapper for the routing, if nextjs or react-router
 */
export const useHistory = (): UseHistoryReturnType => {
  let { routerType } = useTheme()

  routerType = routerType || 'react-router'

  const routerFactoryResult = routerFactory(routerType)
  if (!routerFactoryResult) {
    throw new Error(`Router type ${routerType} is not supported.`)
  }

  return routerFactory(routerType)()
}
